function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg915330502894(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 2200",
    style: {
      enableBackground: "new 0 0 3000 2200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    style: {
      fill: "#FFFFFF"
    },
    width: 3000,
    height: 2200
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1F2FF"
    },
    d: "M2506.081,1906.117H474.098c-15.449-14.722-29.897-30.557-43.146-47.651 c-122.281-157.765-127.593-399.709-17.464-567.253c40.29-61.293,91.402-110.821,137.321-169.9 C657.9,983.526,627.462,780.17,695.69,621.267c64.661-150.593,180.252-274.267,319.504-333.532 c206.363-87.828,471.158-17.614,644.273,126.517c143.256,119.272,252.704,238.313,437.965,252.542 c233.388,17.926,436.221,94.332,572.197,332.351c73.896,129.352,101.567,286.905,86.195,438.775 C2734.076,1652.792,2638.2,1802.925,2506.081,1906.117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E5FD"
    },
    d: "M371.297,1274.252c24.806-37.641,52.734-69.907,82.306-104.073 c19.88-22.857,37.75-43.602,55.149-66c62.008-79.814,77.94-184.054,93.359-284.957c11.112-72.738,22.602-147.954,51.16-214.486 c66.238-154.226,183.154-276.253,320.78-334.791c98.344-41.874,214.488-50.14,335.852-23.887 c112.933,24.485,223.22,78.02,310.551,150.738c21.052,17.482,42.093,35.641,60.653,51.661 c117.204,100.997,218.429,188.22,376.153,200.373c129.507,9.947,235.29,37.375,323.39,83.841 c103.938,54.857,185.891,136.519,250.532,249.648c71.859,125.708,102.604,282.153,86.572,440.519 c-20.024,197.569-104.38,355.702-250.921,470.147l-0.383,0.292h-23.226v-3.402h22.295 c145.468-113.701,229.324-270.964,249.236-467.423c15.956-157.588-14.624-313.236-86.106-438.287 c-64.329-112.585-145.869-193.841-249.277-248.412c-87.759-46.286-193.188-73.615-322.312-83.535 c-158.637-12.213-260.192-99.728-377.785-201.064c-18.554-16.007-39.583-34.16-60.611-51.621 c-86.972-72.425-196.829-125.741-309.326-150.14c-120.816-26.126-236.382-17.92-334.226,23.741 c-136.907,58.226-253.222,179.635-319.13,333.09c-28.37,66.093-39.818,141.063-50.913,213.668 c-15.478,101.276-31.481,205.994-94.043,286.532c-17.452,22.458-35.358,43.236-55.267,66.133 c-29.496,34.08-57.359,66.266-82.041,103.721c-53.411,81.323-81.204,183.183-78.258,286.811 c2.94,104.399,36.919,203.648,95.675,279.462c12.88,16.558,27.31,32.478,42.894,47.322h23.669v3.402H433.44l-0.707-0.086 l-0.442-0.518c-15.779-15.01-30.385-31.116-43.424-47.88c-59.215-76.406-93.459-176.412-96.423-281.595 C289.48,1458.803,317.479,1356.192,371.297,1274.252z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E5FD"
    },
    d: "M2287.099,1702.277c2.956,24.137,4.661,48.275,5.252,72.343 c0.417,15.373,0.347,30.711-0.174,46.014c-0.417,13.008-1.148,26.016-2.261,38.953c-0.173,2.678-0.382,5.356-0.626,8 c-0.782,8.384-1.715,16.746-2.727,25.096h48.151c12.022-20.666,19.913-43.141,27.197-66.763 c19.199-62.083,26.781-129.973,15.79-195.534c-6.434-38.466-21.703-79.125-56.97-104.757 c-22.711-16.521-48.275-5.669-54.848,16.068c-7.443,24.624,0.174,51.613,6.121,76.69 C2278.647,1646.281,2283.691,1674.105,2287.099,1702.277z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9E0FB"
    },
    d: "M2344.382,1657.759c8.242,59.439,6.087,121.139-9.878,179.117 c-5.299,19.213-12.264,37.894-20.843,55.807h3.868c43.926-92.575,44.858-206.376,15.792-302.78 c-6.817-22.538-15.477-45.04-28.346-64.865c-1.182-1.878-4.208-0.139-2.991,1.774 C2326.853,1565.209,2338.191,1612.997,2344.382,1657.759z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E5FD"
    },
    d: "M2512.81,1892.683c18.828-17.177,38.461-33.601,59.104-48.99 c23.198-17.286,47.301-33.18,72.517-47.892c22.711-13.216,47.996-26.607,60.935-49.422 c11.408-20.172,1.426-46.64-26.712-51.787c-43.753-7.965-84.48,9.321-117.417,31.65 c-56.099,38.015-100.897,91.367-133.207,149.206c-3.218,5.754-6.304,11.491-9.301,17.236H2512.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9E0FB"
    },
    d: "M2445.6,1892.683c43.123-67.737,108.015-123.26,177.788-158.756 c21.355-10.852,43.962-20.276,67.612-24.729c2.191-0.417,1.287-3.757-0.904-3.339c-46.848,8.799-91.124,34.85-129.208,62.5 c-46.519,33.776-87.943,75.694-118.934,124.323H2445.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9E0FB"
    },
    d: "M2176.673,1672.505c55.597,60.872,87.781,139.5,103.107,220.178h3.522 c-15.237-80.51-47.023-158.9-101.934-220.143c-1.426-1.635-2.886-3.234-4.382-4.834c-1.53-1.67-4,0.8-2.469,2.434 C2175.246,1670.906,2175.977,1671.705,2176.673,1672.505z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2224.596,1763.494c-11.721,5.208-25.748,6.767-39.136,4.348 c-13.388-2.419-26.05-8.8-35.328-17.802c11.219-6.561,22.975-10.54,36.834-8.386 C2200.826,1743.807,2215.613,1753.793,2224.596,1763.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2268.496,1875.003c-11.88,3.919-25.275,4.166-37.374,0.69s-22.823-10.653-29.919-20.024 c11.648-5.248,23.345-7.996,35.931-4.73C2249.719,1854.204,2261.797,1864.994,2268.496,1875.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2231.791,1644.188c-16.914,13.9-23.241,36.722-15.773,56.896 c11.164-2.075,20.45-12.125,21.799-21.985C2239.166,1669.238,2237.45,1653.219,2231.791,1644.188z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2194.317,1705.913c-20.313,13.843-48.482,9.791-65.371-9.403 C2149.827,1684.432,2176.196,1688.719,2194.317,1705.913z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2308.763,1762.7c-24.357,12.743-38.482,38.229-35.213,63.536 c14.057-0.064,28.118-9.903,32.551-21.209C2310.534,1793.721,2313.02,1774.523,2308.763,1762.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2246,1827.297c-28.441,11.953-61.269,1.194-76.181-24.967 C2198.443,1792.574,2229.031,1803.225,2246,1827.297z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2289.472,1870.453c-2.42-23.585,16.688-41.338,44.342-41.199 C2334.222,1852.114,2315.859,1868.415,2289.472,1870.453z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2128.425,1624.469c13.366,2.6,26.421,7.952,36.4,16.391s16.621,20.13,16.525,31.815 c-14.258-0.018-30.302-3.953-40.376-13.236C2130.9,1650.156,2127.485,1636.723,2128.425,1624.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2282.319,1697.187c1.617,11.694,0.065,23.728-5.96,33.873 c-6.025,10.146-16.795,18.221-29.832,20.686c-4.791-11.874-5.825-26.087,1.107-36.496S2268.365,1699.073,2282.319,1697.187z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M2362.661,1892.683h44.471c0.193-0.384,0.414-0.734,0.6-1.126 c60.133-126.698,170.523-225.014,225.991-353.816c11.777-27.346,13.91-77.461-30.448-72.29 c-44.31,5.165-81.028,36.801-109.206,71.387c-68.479,84.051-97.674,183.228-122.013,287.37 c-4.915,21.032-13.086,44.272-9.846,66.232C2362.329,1891.25,2362.519,1891.919,2362.661,1892.683z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9E0FB"
    },
    d: "M2375.614,1892.683c6.008-61.338,27.313-120.033,53.472-175.615 c28.211-59.944,59.807-118.413,105.812-166.722c24.707-25.945,52.464-48.766,82.582-68.155 c1.876-1.208,0.134-4.22-1.756-3.003c-52.568,33.842-98.011,78.293-132.509,130.479 c-20.032,30.304-36.583,62.972-52.362,95.645c-14.725,30.491-28.167,61.683-38.679,93.895 c-9.924,30.409-16.977,61.678-20.047,93.477H2375.614z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E5FD"
    },
    d: "M614.738,1836.25c1.53,1.878,3.165,3.756,4.869,5.669c2.504,2.957,5.147,6.018,7.756,9.391 c4.487,5.843,8.069,12.346,10.643,19.233c2.703,7.086,4.219,14.578,4.732,22.14h76.678c0.011-3.984-0.271-7.975-0.894-11.949 c-1.531-9.878-4.174-19.755-4.069-29.459c0.035-3.235,0.383-6.434,1.183-9.634c1.044-4.104,2.713-7.895,4.834-11.478 c4.904-8.208,12.068-15.303,18.677-22.677c1.982-2.191,3.896-4.417,5.704-6.712c7.721-9.773,13.077-21.286,15.964-33.424 c3.269-13.599,3.478-27.998,0.487-41.597c-1.043-5.043-2.574-9.947-4.556-14.677c-11.93-28.798-47.197-45.666-48.901-79.854 c-1.218-24.59,18.085-48.936,9.773-72.135c-6.295-17.668-22.154-29.007-37.11-39.093c-7.721-5.217-13.842-8.452-19.129-16.625 c-2.817-4.348-9.286-17.877-9.008-25.077c-5.217,10.017-10.26,20.242-12.799,31.232c-2.365,10.295-1.913,21.146,1.496,31.128 c3.478,10.12,8.382,19.129,8.521,30.154c0.417,28.52-25.528,49.562-37.806,75.264c-7.443,15.512-8.73,32.346-5.947,49.179 c2.817,16.834,11.373,31.337,14.746,47.892c2.191,10.921-1.008,20.555-5.252,30.015c-3.095,6.991-6.782,13.877-9.217,21.146 c-0.626,1.913-1.183,3.895-1.6,5.878c-0.07,0.208-0.104,0.383-0.139,0.592c-3.339,16.242,2.226,25.667,10.33,35.441 C614.703,1836.216,614.738,1836.216,614.738,1836.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E5FD"
    },
    d: "M581.259,1892.683c-2.996-5.744-6.083-11.482-9.3-17.236 c-32.311-57.839-77.108-111.191-133.208-149.206c-32.937-22.329-73.664-39.615-117.418-31.65 c-28.137,5.147-38.119,31.615-26.676,51.787c12.903,22.816,38.189,36.206,60.9,49.422 c25.215,14.712,49.318,30.606,72.516,47.892c20.642,15.389,40.275,31.814,59.104,48.99H581.259z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9E0FB"
    },
    d: "M553.931,1892.683h4.583c-43.588-69.321-109.784-126.161-180.976-162.164 c-21.355-10.817-43.997-20.207-67.647-24.659c-2.157-0.418-3.095,2.921-0.905,3.339c45.562,8.591,88.515,33.632,125.73,60.274 C481.289,1802.817,522.788,1844.432,553.931,1892.683z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9E0FB"
    },
    d: "M735.381,1892.683c20.967-70.731,56.288-137.821,110.401-188.354 c0.73-0.73,1.495-1.391,2.226-2.087c1.635-1.495-0.835-3.965-2.469-2.435c-1.426,1.322-2.852,2.644-4.278,4.034 c-53.588,50.881-88.654,118.099-109.47,188.841H735.381z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M793.721,1786.301c10.632,5.779,23.707,8.297,36.48,7.027c12.773-1.27,25.16-6.32,34.562-14.09 c-10.059-7.013-20.816-11.638-34.012-10.653C817.555,1769.571,802.898,1777.853,793.721,1786.301z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M744.062,1887.877c10.878,4.578,23.458,5.816,35.098,3.455 c11.64-2.361,22.264-8.306,29.642-16.586c-10.561-5.81-21.355-9.273-33.437-7.147S751.114,1878.967,744.062,1887.877z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M795.912,1673.556c14.864,14.343,19.101,36.281,10.563,54.694 c-10.344-2.79-18.323-12.938-18.851-22.313C787.095,1696.561,789.911,1681.625,795.912,1673.556z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M826.521,1734.421c18.065,14.544,44.861,12.848,62.186-3.936 C869.975,1717.559,844.854,1719.611,826.521,1734.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M714.623,1779.236c21.951,13.813,33.321,38.843,28.346,62.398 c-13.216-1.116-25.701-11.425-29.021-22.391C710.629,1808.277,709.732,1790.035,714.623,1779.236z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M768.801,1844.7c25.851,13.377,57.532,5.723,73.521-17.761 C816.134,1815.614,786.567,1823.335,768.801,1844.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M724.676,1882.023c4.047-22-12.591-40.131-38.609-42.076 C683.967,1861.416,700.013,1878.125,724.676,1882.023z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M894.606,1662.772c-12.766,1.441-25.445,5.495-35.464,12.683 c-10.019,7.188-17.143,17.684-17.93,28.681c13.411,1.054,28.795-1.443,38.966-9.417S894.57,1674.366,894.606,1662.772z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M744.412,1719.607c-2.399,10.876-1.843,22.311,3.062,32.305 c4.905,9.994,14.427,18.398,26.503,21.695c5.397-10.807,7.437-24.097,1.699-34.407 C769.938,1728.89,757.394,1722.428,744.412,1719.607z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDE8F9"
    },
    d: "M592.86,1892.683h44.47c0.143-0.764,0.332-1.433,0.451-2.243 c3.24-21.96-4.931-45.2-9.846-66.232c-24.339-104.142-53.533-203.319-122.013-287.37 c-28.178-34.586-64.896-66.222-109.206-71.387c-44.358-5.171-42.224,44.944-30.448,72.29 c55.468,128.802,165.858,227.119,225.991,353.816C592.446,1891.95,592.667,1892.299,592.86,1892.683z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9E0FB"
    },
    d: "M515.373,1613.857c18.731,28.75,34.394,59.536,49.384,90.363 c14.909,30.659,28.551,62.01,39.22,94.415c10.072,30.591,17.284,62.038,20.402,94.048h3.484 c-5.932-60.906-26.796-119.211-52.608-174.503c-28.8-61.691-61.285-121.844-108.707-171.346 c-24.647-25.728-52.329-48.366-82.278-67.647c-1.888-1.215-3.634,1.794-1.756,3.003 C435.388,1516.23,481.024,1561.133,515.373,1613.857z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9E0FB"
    },
    d: "M679.359,1604.337c-1.009,18.503-9.217,32.972-17.564,48.97 c-5.53,10.574-10.121,21.947-7.826,34.05c2.574,13.564,11.025,25.111,17.495,36.971c8.417,15.338,12.103,32.207,10.573,49.631 c-2.748,31.893-19.164,60.622-22.364,92.48c-0.872,8.728-0.987,17.486-0.771,26.244h3.476 c-0.176-6.787-0.169-13.577,0.286-20.366c2.157-32.137,17.807-60.656,22.19-92.306c2.018-14.747,1.044-29.667-4.069-43.719 c-4.73-12.938-13.078-23.998-18.886-36.414c-8.521-18.26-3.617-33.041,5.634-49.875c6.991-12.729,13.008-24.937,14.747-39.58 c1.878-15.547,0.73-33.424-5.599-47.892c-3.061-7.026-7.164-13.46-10.747-20.207c-5.182-9.773-8.799-20.068-11.234-30.815 c-0.487-2.191-3.826-1.286-3.339,0.904c3.478,15.443,9.982,28.624,17.529,42.362 C677.342,1570.183,680.298,1586.808,679.359,1604.337z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C6E5FD"
    },
    cx: 1500,
    cy: 1901.284,
    rx: 1259.924,
    ry: 67.685
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E5FD"
    },
    d: "M1191.127,803.589l1.38-0.552l0.526-0.797l27.774-42.164 c18.22,12.796,40.372,20.37,64.327,20.37c61.932,0,112.135-50.203,112.135-112.135c0-49.864-32.568-92.075-77.575-106.653 l36.464-19.855l1.093-0.595l0.323-1.703l6.372-33.592c5.194,2.52,10.297,5.195,15.196,8.188l42.817-27.18l1.889,1.456 c7.844,6.034,15.234,12.501,21.968,19.246c6.834,6.834,13.301,14.223,19.246,21.968l1.444,1.889l-27.168,42.817 c9.605,15.721,16.838,33.036,21.288,51.44l49.516,11.06l0.311,2.367c1.278,9.745,1.922,19.557,1.922,29.146 c0,9.589-0.645,19.401-1.922,29.146l-0.311,2.367l-49.516,11.06c-4.45,18.404-11.683,35.72-21.288,51.441l27.168,42.818 l-1.444,1.889c-5.957,7.756-12.435,15.146-19.246,21.957c-6.723,6.734-14.112,13.212-21.968,19.257l-1.889,1.456 l-42.817-27.18c-15.726,9.607-33.046,16.841-51.456,21.29l-11.046,49.515l-2.367,0.311 c-9.767,1.267-19.567,1.912-29.146,1.912c-9.567,0-19.367-0.645-29.135-1.912l-2.366-0.311l-11.053-49.517 c-18.412-4.45-35.735-11.687-51.462-21.296l-42.803,27.189l-1.889-1.456c-7.503-5.773-14.541-11.959-21.018-18.368 L1191.127,803.589z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E5FD"
    },
    d: "M1052.126,631.889l0.312-2.367l49.513-11.045c4.449-18.411,11.683-35.733,21.292-51.459 l-27.191-42.814l1.456-1.889c5.967-7.756,12.445-15.146,19.257-21.968c6.733-6.745,14.123-13.212,21.968-19.246l1.889-1.456 l42.803,27.189c15.723-9.607,33.04-16.842,51.447-21.293l11.068-49.521l2.367-0.311c9.768-1.267,19.568-1.911,29.135-1.911 c9.58,0,19.38,0.644,29.146,1.911l2.367,0.311l11.061,49.519c8.413,2.034,16.563,4.718,24.472,7.876l-0.77,36.909 l-32.003,23.951c-10.807-3.466-22.309-5.378-34.266-5.378c-61.932,0-112.138,50.206-112.138,112.138 c0,37.851,18.809,71.25,47.531,91.556l-32.81,36.382l-75.068,19.86c-2.54-2.972-5.064-5.967-7.455-9.078l-1.456-1.889 l27.191-42.815c-9.609-15.726-16.843-33.048-21.292-51.459l-49.513-11.045l-0.312-2.367 c-1.278-9.745-1.922-19.546-1.922-29.146C1050.204,651.434,1050.848,641.633,1052.126,631.889z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6E5FD"
    },
    points: "1356.709,456.605 1356.709,486.919 1366.814,461.657  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6E5FD"
    },
    points: "1111.88,822.061 1070.644,833.432 1076.474,842.371  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6E5FD"
    },
    d: "M1301.263,996.728l-1.072-17.967c19.821-1.178,39.555-4.228,58.638-9.071l4.43,17.457 C1343.068,992.263,1322.209,995.48,1301.263,996.728z M1254.202,996.245c-20.867-1.679-41.656-5.353-61.776-10.917 l4.799-17.351c19.03,5.256,38.685,8.737,58.418,10.319L1254.202,996.245z M1407.947,972.354l-6.856-16.648 c18.248-7.515,35.898-16.833,52.476-27.697l9.862,15.057C1445.911,954.554,1427.241,964.407,1407.947,972.354z  M1148.028,969.55c-19.145-8.377-37.604-18.635-54.849-30.484l10.196-14.837c16.314,11.207,33.762,20.911,51.861,28.831 L1148.028,969.55z M1500.866,914.56l-11.884-13.519c14.846-13.053,28.541-27.583,40.706-43.203l14.205,11.058 C1531.033,885.403,1516.556,900.768,1500.866,914.56z M1056.339,909.743c-15.4-14.152-29.543-29.824-42.025-46.578 l14.433-10.759c11.814,15.857,25.192,30.694,39.775,44.082L1056.339,909.743z M1570.13,829.78l-15.611-8.948 c9.836-17.176,18.081-35.362,24.48-54.041l17.035,5.837C1589.257,792.388,1580.547,811.612,1570.13,829.78z M988.956,823.531 c-10.021-18.389-18.31-37.797-24.656-57.697l17.158-5.467c5.995,18.819,13.835,37.173,23.302,54.551L988.956,823.531z  M1608.086,727.105l-17.685-3.358c3.674-19.347,5.538-39.23,5.538-59.077l12.288-0.914l5.714,0.738 C1613.94,685.643,1611.971,706.651,1608.086,727.105z M953.233,720.073c-3.041-18.169-4.588-36.804-4.597-55.403l0.07-7.129 l18.002,0.334l-0.07,6.795c0.009,17.598,1.468,35.239,4.351,52.432L953.233,720.073z M1592.642,618.953 c-2.848-19.575-7.577-38.966-14.064-57.627l17-5.907c6.865,19.742,11.866,40.241,14.873,60.95L1592.642,618.953z  M970.769,613.547l-17.773-2.901c3.384-20.674,8.746-41.093,15.954-60.686l16.894,6.206 C979.032,574.696,973.96,593.998,970.769,613.547z M1560.998,520.418c-9.062-17.545-19.856-34.334-32.092-49.918 l14.152-11.111c12.939,16.464,24.348,34.219,33.938,52.766L1560.998,520.418z M1004.145,515.557l-15.84-8.544 c9.906-18.38,21.632-35.933,34.852-52.168l13.959,11.357C1024.616,481.566,1013.523,498.179,1004.145,515.557z  M1499.002,437.493c-14.31-13.704-29.965-26.106-46.525-36.865l9.81-15.101c17.501,11.374,34.044,24.48,49.162,38.975 L1499.002,437.493z M1067.599,433.713l-12.236-13.203c15.347-14.213,32.119-27.038,49.839-38.113l9.546,15.259 C1097.978,408.143,1082.12,420.273,1067.599,433.713z M1413.493,379.057c-17.94-8.324-36.76-14.96-55.948-19.733l4.342-17.474 c20.296,5.054,40.205,12.077,59.183,20.876L1413.493,379.057z M1154.057,376.807l-7.296-16.455 c19.136-8.473,39.159-15.145,59.534-19.839l4.043,17.545C1191.081,362.488,1172.139,368.799,1154.057,376.807z  M1313.674,351.677c-19.584-2.022-39.836-2.154-59.35-0.51l-1.512-17.931c20.604-1.758,41.998-1.591,62.708,0.527 L1313.674,351.677z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77C3F0"
    },
    points: "1795.841,1618.081 1695.085,1618.081 1594.33,1618.081 1569.311,1838.187  1695.085,1838.187 1820.86,1838.187  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92D0F6"
    },
    d: "M1993.333,1830.072h-596.494c-23.528,0-42.601,19.073-42.601,42.601l0,0h681.697l0,0 C2035.934,1849.145,2016.86,1830.072,1993.333,1830.072z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92D0F6"
    },
    d: "M2373.661,875.025v747.549c0,28.847-23.39,52.237-52.237,52.237H1068.747 c-28.847,0-52.237-23.39-52.237-52.237V875.025c0-28.847,23.39-52.237,52.237-52.237h1252.677 C2350.271,822.788,2373.661,846.178,2373.661,875.025z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77C3F0"
    },
    d: "M2373.661,875.025v686.325H1016.51V875.025c0-28.847,23.39-52.237,52.237-52.237h1252.677 C2350.271,822.788,2373.661,846.178,2373.661,875.025z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1366.375,
    y: 554.068,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2887.157 -503.0141)",
    style: {
      fill: "#FFFFFF"
    },
    width: 657.421,
    height: 1276.006
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 1695.085,
    cy: 1618.081,
    r: 26.879
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1386.245,
    y: 573.938,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2887.1563 -503.0147)",
    style: {
      fill: "#E1F2FF"
    },
    width: 617.681,
    height: 1236.265
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2114.488,912.24h-985.757c-8.82,0-15.971,7.151-15.971,15.971 c0,8.821,7.151,15.971,15.971,15.971h985.757c8.82,0,15.971-7.149,15.971-15.971 C2130.459,919.391,2123.308,912.24,2114.488,912.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -18.1204 1812.6763)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 2179.034,
    cy: 928.211,
    rx: 14.054,
    ry: 14.054
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 807.4905 2876.7302)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 2221.196,
    cy: 928.211,
    rx: 14.054,
    ry: 14.054
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 6.5779 1872.3033)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 2263.359,
    cy: 928.211,
    rx: 14.054,
    ry: 14.054
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1108.1,
    y: 1067.574,
    style: {
      fill: "#7FC8F4"
    },
    width: 308.046,
    height: 308.046
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1337.544,1229.342l19.953-7.395l-0.005-1.002c-0.021-4.126-0.309-8.239-0.853-12.232 s-1.368-8.033-2.452-12.014l-0.264-0.967l-21.204-1.785c-2.895-7.409-6.898-14.201-11.788-20.199l8.881-19.347l-0.713-0.703 c-2.922-2.888-6.035-5.594-9.255-8.045c-3.183-2.424-6.623-4.695-10.228-6.759l-0.868-0.498l-16.26,13.734 c-7.087-3.106-14.701-5.145-22.612-5.952l-7.406-19.955l-1.002,0.005c-4.134,0.027-8.247,0.314-12.226,0.857 c-3.984,0.543-8.024,1.367-12.014,2.447l-0.967,0.264l-1.792,21.208c-7.406,2.894-14.196,6.896-20.192,11.784l-19.347-8.876 l-0.703,0.713c-2.921,2.954-5.628,6.063-8.046,9.25c-2.455,3.23-4.726,6.67-6.759,10.228l-0.494,0.868l13.726,16.267 c-3.105,7.086-5.144,14.699-5.951,22.61l-19.953,7.402l0.005,1.002c0.021,4.126,0.309,8.243,0.853,12.232 c0.544,3.989,1.368,8.033,2.452,12.014l0.264,0.967l21.207,1.792c2.895,7.406,6.897,14.196,11.785,20.192l-8.871,19.347 l0.708,0.704c2.917,2.888,6.03,5.594,9.25,8.041c3.178,2.42,6.619,4.695,10.229,6.764l0.868,0.498l16.266-13.731 c7.088,3.106,14.703,5.145,22.616,5.951l7.396,19.954l1.002-0.005c4.134-0.027,8.247-0.314,12.231-0.857 c3.979-0.542,8.019-1.366,12.01-2.447l0.967-0.264l1.788-21.207c7.409-2.895,14.202-6.899,20.201-11.79l19.342,8.881 l0.703-0.713c2.925-2.96,5.631-6.073,8.045-9.255c2.444-3.209,4.719-6.65,6.765-10.224l0.498-0.868l-13.735-16.264 C1334.698,1244.871,1336.738,1237.256,1337.544,1229.342z M1268.48,1268.237c-25.759,3.511-49.486-14.523-52.997-40.282 c-3.511-25.759,14.523-49.487,40.282-52.999c25.759-3.511,49.487,14.524,52.999,40.284 C1312.274,1240.998,1294.239,1264.725,1268.48,1268.237z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -494.1321 1250.2529)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 1262.123,
    cy: 1221.597,
    rx: 28.881,
    ry: 28.881
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1479.255,
    y: 1067.574,
    style: {
      fill: "#7FC8F4"
    },
    width: 802.815,
    height: 308.046
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1560.132,
    y: 1133.485,
    style: {
      fill: "#FFFFFF"
    },
    width: 675.883,
    height: 7.802
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1560.132,
    y: 1189.627,
    style: {
      fill: "#FFFFFF"
    },
    width: 675.883,
    height: 7.802
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1560.132,
    y: 1245.768,
    style: {
      fill: "#FFFFFF"
    },
    width: 675.883,
    height: 7.802
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1560.132,
    y: 1301.894,
    style: {
      fill: "#FFFFFF"
    },
    width: 675.883,
    height: 7.818
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M933.658,1784.735l1.679,49.387c0.25,7.367-0.079,13.913,6.719,16.764l36.648,17.992 c19.132,8.024,13.397,29.094-7.349,29.094h-95.747v-29.173l-2.09-84.064H933.658z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193368"
    },
    d: "M885.398,1866.509c-1.496-0.849-4.927-2.819-6.052-3.274 c-3.833-1.548-7.656,2.193-7.656,6.291v48.68c0,4.102,3.326,7.428,7.428,7.428h180.316c5.379,0,9.733-4.354,9.733-9.733 c0-0.64-0.128-1.409-0.256-2.049c-0.64-2.946-2.69-5.507-5.635-6.788l-107.398-52.046c-5.95-2.949-10.524-0.662-11.667,4.635 c-1.881,8.715-9.452,14.025-27.326,13.796C903.91,1873.283,892.59,1870.591,885.398,1866.509z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193972"
    },
    d: "M871.69,1913.852v4.354c0,4.098,3.33,7.428,7.428,7.428h180.316 c5.379,0,9.733-4.354,9.733-9.733c0-0.64-0.128-1.409-0.256-2.049H871.69z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC5BD"
    },
    points: "687.471,1802.712 676.537,1900.194 618.632,1900.194 629.565,1802.712  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193368"
    },
    d: "M557.207,1922.728c1.739,6.209,7.575,10.973,19.744,11.842 c17.261,1.118,63.332-0.621,86.304-3.849c14.032-1.862,18.875-5.26,19.372-13.953c0.124-2.112,0.249-4.47,0.373-7.078 c0.248-10.803,0.084-23.114-0.47-35.424c-0.117-2.605-3.104-4.098-5.215-2.359c-6.209,4.968-10.191,6.657-16.888,7.078 c-7.376,0.464-13.95-3.482-13.687-10.031c0.273-6.829-5.463-8.941-18.005-8.941c-7.451,0-12.17,0.13-22.601,9.319 c-11.673,10.431-41.103,34.273-46.071,38.868C556.958,1911.055,555.468,1917.016,557.207,1922.728z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193972"
    },
    d: "M557.207,1922.728c1.739,6.209,7.575,12.169,19.744,13.039 c17.261,1.118,63.332-0.621,86.304-3.849c14.032-1.862,18.875-6.457,19.372-15.149c0.124-2.112,0.249-4.47,0.373-7.078 c-2.732,4.967-7.823,9.065-17.51,10.431c-24.091,3.602-77.612,4.967-95.741,3.974 C565.403,1923.846,561.181,1923.473,557.207,1922.728z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#193972"
    },
    points: "610.128,1843.842 632.619,1485.403 654.934,1108.331 739.206,1072.872  819.746,1112.563 758.029,1485.403 698.696,1843.842  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#193972"
    },
    points: "860.939,1843.842 820.094,1485.403 777.603,1112.521 858.059,1072.872  936.577,1117.349 945.768,1485.403 949.489,1843.842  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193368"
    },
    d: "M798.336,1262.416c1.492,0,2.807-1.079,3.056-2.595l22.077-133.383 c0.279-1.692-0.861-3.292-2.553-3.571c-1.704-0.291-3.292,0.861-3.571,2.553l-22.077,133.383 c-0.279,1.692,0.861,3.292,2.553,3.571C797.997,1262.404,798.167,1262.416,798.336,1262.416z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M938.224,718.395c14.206,23.453,7.457,53.737-14.89,69.039 c-0.797,0.546-1.613,1.072-2.45,1.579c-24.289,14.713-55.905,6.949-70.618-17.339c-14.712-24.289-6.949-55.906,17.339-70.618 C891.895,686.344,923.512,694.107,938.224,718.395z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2385 -0.9712 0.9712 0.2385 -131.8357 1676.8634)",
    style: {
      fill: "#FFC5BD"
    },
    cx: 1003.284,
    cy: 922.493,
    rx: 36.711,
    ry: 36.711
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M850.281,771.665L850.281,771.665c39.357,65.911,72.825,109.246,120.96,169.048l0.644,0.8 l62.799-38.04l0,0c-40.187-65.408-65.327-113.787-96.035-184.145l-0.411-0.941L850.281,771.665z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63B6D3"
    },
    d: "M951.193,731.272c-19.198-35.969-53.641-49.294-83.794-32.259 c-21.875,12.358-28.953,44.231-25.684,65.795c0.971,6.405,7.768,21.022,10.573,26.737 c9.769,19.909,54.96,94.511,77.696,127.059l90.411-46.925C996.507,825.927,971.164,768.69,951.193,731.272z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M1162.475,913.913l-7.051-45.791c-23.199,3.291-44.628,8.656-75.909,11.978 c-34.915,3.707-65.407,6.18-82.369,6.81l11.068,71.881l-0.001,0C1063.224,947.286,1118.704,932.947,1162.475,913.913z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -358.5521 979.8315)",
    style: {
      fill: "#FFC5BD"
    },
    cx: 1003.485,
    cy: 922.726,
    rx: 36.364,
    ry: 36.364
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.678 -0.7351 0.7351 0.678 -281.4044 1139.457)",
    style: {
      fill: "#FFC5BD"
    },
    cx: 1159.754,
    cy: 890.894,
    rx: 23.165,
    ry: 23.165
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63B6D3"
    },
    d: "M653.28,1048.218c-0.746,8.693-2.234,28.438-3.602,50.914h287.352 c-5.465-85.684-10.183-171.119-15.151-254.691l8.818-138.956c-17.883-14.777-53.273-33.776-80.096-42.593l-103.192-3.104 c-38.87,10.431-75.253,26.574-100.462,43.09l3.477,133.369C655.514,923.418,658.991,989.854,653.28,1048.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A6BF"
    },
    d: "M807.72,726.477c9.526,0,18.354-1.892,26.236-5.627c15.334-7.258,26.74-21.64,30.511-38.466 c0.37-1.673-0.679-3.335-2.353-3.711c-1.71-0.364-3.335,0.685-3.711,2.353c-3.353,14.977-13.485,27.764-27.103,34.21 c-9.144,4.335-20.149,5.821-31.208,4.608c-21.452-2.328-50.084-15.777-60.198-46.003c-0.552-1.631-2.353-2.492-3.929-1.965 c-1.631,0.546-2.504,2.304-1.964,3.929c11.054,33.021,42.147,47.683,65.418,50.211 C802.172,726.32,804.937,726.477,807.72,726.477z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M747.468,659.727l51.671-13.09l51.478,16.199l-0.005,5.659 c0.257,15.465-10.256,28.865-22.349,34.407c-8.241,3.777-17.36,4.548-26.206,3.616 C776.987,703.878,751.86,687.81,747.468,659.727z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC5BD"
    },
    points: "836.719,680.062 836.765,658.006 837.004,547.161 758.314,547 758.225,583.116  758.023,680.264  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF9B8F"
    },
    d: "M758.225,583.116c6.348,40.33,39.105,70.608,78.54,74.889l0.239-110.845L758.314,547 L758.225,583.116z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M1189.666,856.435c-7.622-1.213-13.355,3.36-13.355,3.36v2.268l6.677,3.856L1189.666,856.435z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#429FD7"
    },
    d: "M1179.742,696.092l0,57.425h-0.005v89.24l77.284,44.623l77.284-44.623v-86.295l0.005-0.003 l0-60.36c50.364,27.429,84.548,80.828,84.548,142.213c0,89.381-72.457,161.835-161.838,161.835 c-89.379,0-161.835-72.454-161.835-161.835C1095.186,776.923,1129.373,723.521,1179.742,696.092z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1173.897,
    y: 947.359,
    style: {
      fill: "#429FD7"
    },
    width: 166.25,
    height: 712.048
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#429FD7"
    },
    d: "M1095.186,1763.797c0,89.379,72.458,161.836,161.836,161.836 c89.381,0,161.837-72.457,161.837-161.836c0-89.38-72.456-161.836-161.837-161.836 C1167.644,1601.961,1095.186,1674.417,1095.186,1763.797z M1168.438,1712.652l88.583-51.145l88.587,51.145v102.289 l-88.587,51.145l-88.583-51.145V1712.652z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M1221.768,855.453c1.922,0.617,3.908,1.159,5.494,2.354c2.993,2.254,3.919,6.269,4.641,9.945 c4.203,0.072,7.864,3.299,9.573,7.139c1.709,3.841,1.804,8.194,1.565,12.391c-0.291,5.097-1.006,13.099-4.65,17.054 c-2.962,3.215-7.587,1.038-8.184-2.92c-0.279-1.844,0.051-3.717,0.247-5.572c0.274-2.588,0.288-5.203,0.042-7.793 c-1.616,3.088-3.233,6.175-4.849,9.263c-0.8,1.527-1.613,3.075-2.784,4.34c-2.357,2.545-6.295,3.568-8.62,0.71 c-3.091-3.8-1.528-8.428-1.169-12.797c0.168-2.047,0.325-4.096,0.419-6.148c0.045-0.967-0.441-4.497,0.104-5.181 c-1.888,2.369-3.098,5.192-4.588,7.83s-3.387,5.208-6.109,6.539s-6.425,1.04-8.289-1.348c-1.827-2.34-1.353-5.671-0.789-8.586 c1.173-6.059,2.347-12.117,3.521-18.176c-2.257,3.717-4.514,7.434-6.771,11.151c-1.264,2.083-2.664,4.715-5.21,5.096 c-2.249,0.336-5.161-0.843-6.444-2.703c-1.403-2.035-1.361-4.7-1.266-7.17c0.283-7.339-0.218-15.164,0.831-22.384 c1.431-9.851,10.038-18.411,19.66-9.974c1.143,1.002,2.106,2.206,3.321,3.118c3.566,2.675,8.907,2.567,11.85,5.916 c1.399,1.592,2.032,3.759,3.503,5.284C1218.14,854.201,1219.925,854.861,1221.768,855.453z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#193368"
    },
    points: "648.774,1091.234 647.701,1119.9 936.577,1125.114 936.551,1096.408  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193972"
    },
    d: "M800.87,1100.477l-0.046,15.011c-0.024,7.878,6.057,14.399,13.559,14.543l31.339,0.619 c3.522,0.011,6.883-1.374,9.463-3.894c2.785-2.717,4.389-6.578,4.401-10.578l0.046-15.011 c0.024-7.878-6.057-14.406-13.559-14.55l-31.129-0.605c-3.662-0.011-7.093,1.367-9.667,3.887 C802.486,1092.629,800.882,1096.484,800.87,1100.477z M851.593,1116.154c-0.006,1.866-0.731,3.647-2.002,4.885 c-1.048,1.022-2.259,1.509-4.036,1.618l-31.014-0.618c-3.165-0.061-5.729-2.992-5.718-6.526l0.046-15.011 c0.006-1.866,0.731-3.647,2.002-4.885c1.06-1.041,2.425-1.61,3.833-1.606l0.096,0l31.129,0.605 c3.159,0.054,5.723,2.985,5.712,6.526L851.593,1116.154z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD683"
    },
    d: "M646.946,1108.32h117.846c21.731,0,39.737-16.888,41.352-38.372 c0.249-1.117,0.249-2.359,0.249-3.477l-0.249-47.808v-3.602l-0.994-187.386c-10.072-50.432-49.483-128.577-80.468-163.295 l-7.204,1.615c-14.404,3.104-25.526,9.218-38.19,17.91c3.373,2.458,6.279,5.063,8.637,7.795h0.124 c30.672,33.404,37.254,68.05,35.762,101.578c-0.744,21.98-4.966,43.463-7.946,63.828 c-8.072,55.508-56.626,80.343-56.626,80.343L646.946,1108.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD683"
    },
    d: "M877.842,671.721l0.22,0.049c13.499,2.975,26.01,9.359,36.343,18.542 c-11.902,41.582-4.688,109.161,4.407,143.53l25.045,274.489h-65.279c-22.626,0-41.101-18.088-41.578-40.709l-4.567-239.724 C839.013,775.625,858.045,711.646,877.842,671.721z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "674.567,1039.106 806.19,1036.44 806.083,1015.107 675.74,1017.668  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M672.648,1072.599l133.435-2.667c0.212-1.173,0.212-2.24,0.212-3.413l-0.105-17.919 l-132.263,2.667L672.648,1072.599z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "835.916,1015.214 836.342,1036.547 937.458,1038.573 935.537,1017.241  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M836.555,1048.706l0.426,18.88c0,0.853,0.107,1.706,0.214,2.56l103.357,2.027l-1.92-21.439 L836.555,1048.706z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M625.767,1181.921l48.274-3.925c-2.374-29.195-2.717-72.418-1.994-115.253 c0.615-36.447-0.113-68.479-1.553-86.197l-75.78,6.161v0c8.147,70.768,18.953,133.423,30.977,198.793L625.767,1181.921z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9337 -0.3581 0.3581 0.9337 -309.1664 291.6035)",
    style: {
      fill: "#FFC5BD"
    },
    cx: 632.673,
    cy: 980.474,
    rx: 38.015,
    ry: 38.015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4782 -0.8783 0.8783 0.4782 -697.8881 1187.0552)",
    style: {
      fill: "#FFC5BD"
    },
    cx: 649.973,
    cy: 1180.806,
    rx: 24.217,
    ry: 24.217
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 717.928,
    y: 1296.705,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1494.4808 2721.1294)",
    style: {
      fill: "#78BBF2"
    },
    width: 58.624,
    height: 127.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M732.255,758.295c-4.627,27.893-30.241,47.066-58.005,44.039 c-0.99-0.108-1.983-0.244-2.977-0.409c-28.888-4.792-48.422-32.094-43.63-60.982c4.792-28.888,32.094-48.422,60.982-43.63 C717.512,702.104,737.047,729.407,732.255,758.295z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9639 -0.2664 0.2664 0.9639 -237.9713 204.0506)",
    style: {
      fill: "#FFC5BD"
    },
    cx: 633.08,
    cy: 979.111,
    rx: 37.856,
    ry: 37.856
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M627.659,740.946L627.659,740.946c-13.979,67.778-31.873,165.332-31.892,230.912l-0.033,1.058 l74.691,12.389l0,0c14.911-74.621,34.226-151.356,61.536-225.995l0.31-1.012L627.659,740.946z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63B6D3"
    },
    d: "M744.448,755.148c4.69-29.971-18.408-58.477-51.591-63.67 c-25.716-4.024-48.504,8.093-60.288,27.268c-3.5,5.695-5.519,12.019-7.105,18.389c-5.527,22.191-12.115,43.568-16.794,66.057 c-6.544,31.453-12.936,81.42-16.278,113.41l105.847,20.802c10.582-51.994,29.831-115.491,42.286-166.261L744.448,755.148z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A6BF"
    },
    d: "M698.24,940.51c-0.121,0-0.249-0.006-0.37-0.024l-14.704-1.771 c-1.704-0.2-2.917-1.746-2.71-3.45c0.212-1.704,1.795-2.917,3.45-2.71l11.623,1.395l14.195-118.321 c0.206-1.704,1.849-2.898,3.45-2.71c1.704,0.2,2.917,1.746,2.71,3.45l-14.564,121.408c-0.097,0.818-0.515,1.564-1.164,2.074 C699.611,940.28,698.932,940.51,698.24,940.51z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD683"
    },
    d: "M720.258,794.252c-1.622,25.117-4.458,59.815-8.177,84.565 c26.036-35.923,44.346-106.82,35.388-137.87c-15.197-52.674-49.995-55.231-60.987-50.865 C709.781,712.456,722.421,760.76,720.258,794.252z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2379 -0.9713 0.9713 0.2379 116.212 1275.9729)",
    style: {
      fill: "#EF9B8F"
    },
    cx: 871.235,
    cy: 563.929,
    rx: 18.76,
    ry: 16.703
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M741.558,533.636c1.44,32.191,9.718,59.218,27.943,83.242 c6.941,9.15,16.337,16.738,27.157,21.357c20.457,8.731,47.537,6.252,61.851-10.389c12.758-14.831,17.652-35.541,19.253-55.206 c1.692-20.787,1.731-41.702-0.245-62.437c-2.797-29.355-32.115-52-72.203-50.054 C760.249,462.339,739.878,496.052,741.558,533.636z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193368"
    },
    d: "M805.321,456.501c40.16-1.875,72.736,21.08,75.809,53.352c0.498,3.87,0.22,4.719,0.22,4.719 c-27.792,11.142-68.204,11-97.139,2.622l-0.181-0.278c-1.67,9.442-7.682,18.589-14.068,22.327l1.37,29.35l-9.2,0.43 l-19.153,0.894c-2.813-11.123-4.464-23.102-5.072-36.113C735.92,488.916,762.294,458.582,805.321,456.501z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193368"
    },
    d: "M857.927,556.645c2.772-0.692,5.582,0.995,6.273,3.768c0.694,2.773-0.993,5.582-3.768,6.275 c-2.772,0.692-5.582-0.995-6.273-3.768C853.468,560.147,855.152,557.338,857.927,556.645z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193368"
    },
    d: "M816.062,558.6c2.775-0.692,5.582,0.995,6.276,3.768c0.691,2.773-0.996,5.582-3.768,6.275 c-2.775,0.692-5.582-0.995-6.276-3.768C811.603,562.102,813.29,559.292,816.062,558.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193368"
    },
    d: "M799.71,543.78c0.202-1.092,1.557-1.773,2.833-2.021c5.946-1.157,11.947-0.724,17.85,0.309 c2.077,0.364,7.701,0.867,6.944,3.671c-0.491,1.819-3.7,3.269-5.758,3.163c-4.591-0.238-9.171-0.588-13.733-1.054 C805.263,547.584,799.043,547.378,799.71,543.78z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193368"
    },
    d: "M849.908,542.343c5.439-2.573,11.386-3.592,17.409-3.995c1.68-0.112,3.452-0.422,5.105-0.131 c0.755,0.133,1.476,0.391,1.966,0.917c0.577,0.618,0.812,2.167,0.505,2.946c-0.303,0.77-1.035,1.382-1.853,1.783 c-2.355,1.155-5.273,1.447-7.85,1.892c-2.793,0.482-5.594,0.921-8.4,1.315c-2.582,0.363-8.676,1.658-9.057-2.05 C847.62,543.892,848.74,542.895,849.908,542.343z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF9B8F"
    },
    d: "M843.408,592.865c0.206-0.01,0.41-0.062,0.612-0.156c3.051-1.484,5.022-3.464,5.844-5.882 c0.748-2.19,0.491-4.575-0.755-7.079c-0.697-1.406-1.737-3.142-2.921-5.09c-1.446-2.379-3.078-5.077-4.445-7.829 c-0.376-0.766-1.289-1.093-2.084-0.698c-0.759,0.381-1.08,1.313-0.692,2.078c1.421,2.871,3.091,5.628,4.565,8.06 c1.131,1.859,2.131,3.518,2.801,4.859c0.858,1.738,1.065,3.319,0.596,4.695c-0.533,1.585-2.021,3.002-4.276,4.097 c-0.759,0.375-1.093,1.301-0.717,2.073C842.216,592.569,842.802,592.894,843.408,592.865z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M845.61,602.738l-31.145-2.408C819.849,613.507,840.589,615.286,845.61,602.738z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD683"
    },
    d: "M732.251,519.68c-0.783,8.164-0.285,16.197,1.378,23.961 c-0.012,0.126-0.012,0.126-0.012,0.126c0.86,4.265,2.243,8.327,3.752,12.401c24.503-32.125,64.373-51.37,107.45-47.238 c16.453,1.578,31.701,6.463,45.325,13.726c-0.285-4.97-1.069-9.988-2.27-14.666c-6.788-27.015-27.376-48.888-54.64-56.699 c-4.675-1.463-9.526-2.435-14.549-2.916c-6.405-0.614-12.757-0.463-18.942,0.591 C764.412,453.941,735.816,482.505,732.251,519.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD683"
    },
    d: "M832.003,458.562l1.232-7.272c-2.211-1.733-6.908-4.125-11.533-4.568 c-4.625-0.444-16.248-0.935-25.768,0.991l-6.105,3.31l12.206,6.085L832.003,458.562z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC255"
    },
    d: "M833.235,451.29c17.226,10.463,33.326,31.672,37.201,47.948 c5.084,0.802,13.386,5.099,17.439,8.751C881.087,480.974,860.5,459.101,833.235,451.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC255"
    },
    d: "M799.745,448.964c14.215,8.723,26.69,28.29,29.635,45.912 c-7.166,0.312-17.094,1.429-28.805,4.827c-1.928-2.422-4.337-4.754-6.731-6.607c-3.872-2.995-9.002-3.801-13.593-2.103 c-6.25,2.311-12.982,5.69-18.317,9.504c-3.81,2.721-6.336,6.951-6.669,11.62c-0.287,4.058-0.056,8.066,0.147,10.537 c-9.779,7.52-16.989,15.138-21.783,20.986c-1.663-7.764-2.161-15.797-1.378-23.961 C735.816,482.505,764.412,453.941,799.745,448.964z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC255"
    },
    d: "M735.134,553.037c19.757-27.235,47.781-42.213,81.865-49.41 c28.977-6.093,56.992-1.533,73.871,6.17c3.763,1.755,7.01,3.587,9.502,5.347c13.862,10.076-10.163,16.604-21.723,16.457 l-0.313-10.533c-12.459-4.244-43.366-8.187-73.318-0.817c-24.414,6.009-52.391,20.29-65.643,37.503 c-0.656,0.856-1.158,1.505-1.718,2.212L735.134,553.037z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193368"
    },
    d: "M762.507,561.666l-0.373,7.357l-3.052,18.727l-0.856,23.494 c-3.244-6.956-13.116-31.581-15.245-41.327L762.507,561.666z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9449 -0.3274 0.3274 0.9449 -144.7067 278.915)",
    style: {
      fill: "#FFC5BD"
    },
    cx: 756.151,
    cy: 569.302,
    rx: 16.703,
    ry: 18.76
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF9B8F"
    },
    d: "M765.363,571.871c0.036-0.002,0.06-0.003,0.097-0.005c0.845-0.094,1.465-0.864,1.377-1.715 c-0.172-1.601-0.646-3.169-1.395-4.651c-2.551-4.974-7.975-8.041-12.973-7.17c-0.867,0.144-1.705,0.407-2.513,0.779 c-1.593,0.73-2.97,1.911-3.981,3.403c-0.477,0.714-0.286,1.677,0.428,2.153c0.703,0.489,1.677,0.298,2.154-0.416 c0.692-1.04,1.603-1.817,2.696-2.323c0.559-0.257,1.145-0.436,1.735-0.536c3.592-0.55,7.74,1.715,9.678,5.521 c0.587,1.138,0.947,2.347,1.078,3.58C763.831,571.311,764.551,571.909,765.363,571.871z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A6BF"
    },
    d: "M925.657,913.05c0.043,0,0.085,0,0.127,0c1.71-0.073,3.044-1.516,2.977-3.232l-4.663-114.774 c-0.073-1.704-1.534-3.026-3.232-2.977c-1.71,0.073-3.044,1.516-2.977,3.232l4.663,114.774 C922.626,911.74,923.996,913.05,925.657,913.05z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 718.93,
    y: 1297.485,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1497.4075 2724.699)",
    style: {
      fill: "#85CBF5"
    },
    width: 59.547,
    height: 129.729
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85CBF5"
    },
    d: "M709.487,1299.168l-12.5,0.021l-0.034-19.984c-0.021-12.433-10.159-22.536-22.586-22.514 l-40.358,0.069c-12.439,0.021-22.542,10.159-22.52,22.592l0.034,19.984l-12.5,0.021l-0.034-19.983 c-0.033-19.33,15.663-35.08,34.999-35.114l40.357-0.069c19.324-0.033,35.074,15.663,35.107,34.993L709.487,1299.168z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 529.782,
    y: 1297.485,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1248.496 2724.699)",
    style: {
      fill: "#ACDAFA"
    },
    width: 188.933,
    height: 129.729
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 525.77,
    y: 1296.899,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1308.475 2618.2493)",
    style: {
      fill: "#70BEED"
    },
    width: 256.934,
    height: 24.451
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1F2FF"
    },
    d: "M564.759,1380.149h5.557v0h8.635l4.318-7.479l-4.318-7.478h-8.35l0,0l-5.841,0 c2.654-4.873,7.821-8.181,13.761-8.181c8.649,0,15.66,7.011,15.66,15.66c0,8.649-7.011,15.66-15.66,15.66 C572.581,1388.331,567.414,1385.023,564.759,1380.149z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 615.481,
    y: 1338.22,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -749.1465 1996.1949)",
    style: {
      fill: "#E1F2FF"
    },
    width: 16.087,
    height: 68.902
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1F2FF"
    },
    d: "M668.076,1388.331c8.649,0,15.66-7.011,15.66-15.66c0-8.649-7.011-15.66-15.66-15.66 c-8.649,0-15.66,7.011-15.66,15.66C652.416,1381.319,659.428,1388.331,668.076,1388.331z M663.127,1381.243l-4.949-8.572 l4.949-8.572h9.898l4.949,8.572l-4.949,8.572H663.127z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.998 -0.0629 0.0629 0.998 -73.0598 43.2612)",
    style: {
      fill: "#FFC5BD"
    },
    cx: 650.039,
    cy: 1181.113,
    rx: 24.164,
    ry: 24.164
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5BD"
    },
    d: "M625.897,1180.059c0.257,4.562,0.193,9.083-0.026,13.766 c-0.454,9.712-5.453,18.493-8.58,27.699c-2.478,7.295-3.739,14.935-4.432,22.591c-0.611,6.754-2.414,14.89-0.399,21.535 c0.902,2.976,3.026,5.767,6.018,6.612c1.083,0.306,2.237,0.35,3.285,0.761c2.512,0.984,3.83,3.795,6.149,5.173 c3.399,2.018,7.834,0.448,11.637,1.526c4.243,1.203,7.446,5.62,11.854,5.462c5.273-0.189,8.658-6.876,13.933-6.838 c3.04,0.022,5.736,2.362,8.774,2.241c1.453-0.058,2.827-0.684,4.059-1.456c5.507-3.455,9.478-12.16,8.641-18.607 c-0.023-0.179-2.017-1.255-2.427-1.496c-0.978-0.574-1.411-1.495-1.507-2.444c-0.191-1.876,0.807-4.388,1.94-5.862 c1.633-2.124,4.501-3.095,6.697-1.768c4.299,2.596,6.952,5.508,10.43,9.311c3.942-7.355,6.141-18.789,2.396-28.172 c-1.883-4.716-4.222-9.543-7.55-13.411c-3.875-4.504-8.654-8.129-12.505-12.659c-5.673-6.673-9.715-14.71-10.079-23.461 L625.897,1180.059z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C0E2FC"
    },
    points: "2332.191,1356.163 2058.598,1873.197 2605.784,1873.197  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70BEED"
    },
    d: "M2621.02,1865.138l-273.597-517.031c-2.989-5.662-8.826-9.176-15.228-9.176 s-12.246,3.514-15.235,9.173l-273.591,517.034c-2.807,5.302-2.632,11.795,0.464,16.955c3.097,5.143,8.759,8.341,14.764,8.341 h547.188c6.005,0,11.667-3.198,14.764-8.341C2623.653,1876.943,2623.834,1870.447,2621.02,1865.138z M2087.216,1855.965 l244.979-462.951l244.979,462.951H2087.216z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70BEED"
    },
    d: "M2318.972,1746.469l-12.216-124.492v-57.564h50.869v57.564l-12.047,124.492H2318.972z  M2308.763,1809.722V1762.7h47.021v47.021H2308.763z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg915330502894);
export default __webpack_public_path__ + "static/media/91533050_2894.6a1ec13d276a05ec6bce2d8f5b7208c1.svg";
export { ForwardRef as ReactComponent };